export const environment = {
  production: true,
  appTitle: 'پیشخوان تحویل دهندگان خانه و اشپزخانه زیبا',
  siteAddress: 'https:/deliverer.zibachiz.com',
  apiUrl: 'https://api.zibachiz.com/v1',
  imageUrl: 'https://api.zibachiz.com/media/',
  firebase: {
    apiKey: "AIzaSyBHhXpwB5lZkv6yjq1xPo1DaYRD1WnMm-Q",
    authDomain: "2015.firebaseapp.ir",
    projectId: "2015",
    storageBucket: "2015.appspot.ir",
    messagingSenderId: "605275400385",
    appId: "1:605275400385:web:dd8e669b165210af2a0c40",
    measurementId: "G-CKTERRSNPX"
  }
};
